// Shapes
import { UserShape } from "~shapes/user"
import { EntityStatus } from "~utils/utils"

export const isUserActive = (user: UserShape): boolean => {
  return user.status === EntityStatus.ACTIVE
}
